import { render, staticRenderFns } from "./EditSchedules.vue?vue&type=template&id=4c36c3ad&"
import script from "./EditSchedules.vue?vue&type=script&lang=js&"
export * from "./EditSchedules.vue?vue&type=script&lang=js&"
import style0 from "./EditSchedules.vue?vue&type=style&index=0&id=4c36c3ad&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports